import React from 'react';

import css from './ProgressBar.module.scss';

const INACTIVE = '#c4c4c4';

const ACTIVE = '#589ea6';

const ProgressBar = props => {
  const { current, total } = props;

  if (!total || total < 1) return <div />;

  const totalSteps = Array(total - 1).fill('progress');

  return (
    <div className={css.progressBarWrapper} data-e2e="progress-bar-wrapper">
      <div className={css.progressBarContainer}>
        <div
          className={css.progressBar}
          data-e2e="progress-bar"
          data-testid="progress-bar"
        >
          {totalSteps.map((name, index) => {
            let circle = (
              <div className={css.currentStep} data-testid="currentStep" />
            );
            if (index + 1 > current) {
              circle = (
                <div className={css.futureStep} data-testid="futureStep" />
              );
            }
            if (index + 1 < current) {
              circle = (
                <div className={css.completedStep} data-testid="completedStep">
                  <svg
                    width="9"
                    height="7"
                    viewBox="0 0 9 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.666626 4.25L3.99996 5.91667L7.74996 0.5"
                      stroke="white"
                    />
                  </svg>
                </div>
              );
            }

            return (
              <div className={css.progressBarImages} key={`${index}`}>
                {circle}
                {index !== totalSteps.length - 1 && (
                  <svg
                    width="25"
                    height={index + 1 >= current ? '1' : '3'}
                    viewBox={index + 1 >= current ? '0 0 25 1' : '0 0 25 3'}
                    fill={ACTIVE}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="25"
                      height={index + 1 >= current ? '1' : '3'}
                      fill={index + 1 >= current ? INACTIVE : ACTIVE}
                    />
                  </svg>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
